import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { Injectable } from '@angular/core';
import { ControlDataExportCommand } from '../../../rent/command/control-data-export.command';
import { RegenerateControlDataCommandHandler } from '../../../accounting/service/command/regenerate-control-data-command-handler.service';
import { GenerateNewControlDataFileCommandHandler } from './generate-new-control-data-file-command-handler.service';

@Injectable()
export class ControlDataExportCommandHandlerResolver extends CommandHandlerResolver {
  constructor(newControlData: GenerateNewControlDataFileCommandHandler) {
    super();
    this.addHandler(ControlDataExportCommand.generateNewControlDataFile, newControlData);
  }
}
